import RetroPoint from './RetroPoint';

export default RetroPoint;
